import React from 'react';
import {InputItem} from 'antd-mobile';
import './ImageCode.less';

class ImageCode extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            value: '',
            time: +new Date()
        }
    }
    updateCode = ()=>{
        this.setState({
            time: +new Date()
        })
    }
    onChange = (val)=>{
        let onChange = this.props.onChange;
        let cid = this.state.time;
        onChange && onChange({verifyCode: val, cid});
        this.setState({
            value: val
        });
    }
    onFocus = ()=>{
       var el = this.refs.input;
        setTimeout(function(){
            el.scrollIntoView && el.scrollIntoView(false);
        }, 400); //弹出输入法的时间间隔
    }
    render(){
      let codeUrl = `/FSC/N/Captcha/Get?cid=${this.state.time}&lan=en`;
        let {errorText} = this.props;

        return (
            <div className="image-code">
                <InputItem className="image-code__input" ref="input" value={this.state.value} onChange={this.onChange} onFocus={this.onFocus} >
                    {errorText && <div className='input-error'>{errorText}</div>}
                </InputItem>
                <img className="image-code__code" src={codeUrl} onClick={this.updateCode}  alt={$st("图形验证码")}/>
            </div>
        )
    }
}
export default ImageCode;



// WEBPACK FOOTER //
// ./src/component/ImageCode/ImageCode.js